import { render, staticRenderFns } from "./ShowAdminsDES.vue?vue&type=template&id=21123e06"
import script from "./ShowAdminsDES.vue?vue&type=script&lang=js"
export * from "./ShowAdminsDES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports